import React from 'react'
import SbEditable from 'storyblok-react'
import Richtext from '../../atoms/Richtext'
import Link from '../../atoms/Link'
import Image from '../../atoms/Image'

const ImageSpreadsBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="image-spreads-block">
        <div className="image-spreads-block-container">
          {block.slides?.length > 0 &&
            block.slides.map((item, index) => (
              <div className="image-spreads-block-spread" key={index}>
                <div className="image-spreads-block-spread-image">
                  <Image
                    className="img-fluid"
                    image={item.image}
                    alt={item.alt}
                    imageWidth="1920"
                    imageHeight="1440"
                  />
                </div>
                <div className="image-spreads-block-spread-text">
                  {item.title?.length > 0 && <h2>{item.title}</h2>}
                  <Richtext text={item.subtitle} />

                  {item.link?.cached_url?.length > 0 && (
                    <Link className="btn btn-primary" link={item.link}>
                      {item.link_text}
                    </Link>
                  )}
                </div>
              </div>
            ))}
        </div>
      </section>
    </SbEditable>
  )
}

export default ImageSpreadsBlock
